var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCoinbase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coinbase-wallet-logo (1) 1",
    clipPath: "url(#clip0_6804_35251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2484 0H23.7504C27.2028 0 30 3.0096 30 6.7224V23.2776C30 26.9904 27.2028 30 23.7516 30H6.2484C2.7972 30 0 26.9904 0 23.2776V6.7224C0 3.0096 2.7972 0 6.2484 0Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.34521C20.8848 4.34521 25.6548 9.11522 25.6548 15C25.6548 20.8848 20.8848 25.6548 15 25.6548C9.11522 25.6548 4.34521 20.8848 4.34521 15C4.34521 9.11522 9.11522 4.34521 15 4.34521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3754 11.5945H17.623C18.055 11.5945 18.4042 11.9713 18.4042 12.4345V17.5645C18.4042 18.0289 18.0538 18.4045 17.623 18.4045H12.3754C11.9434 18.4045 11.5942 18.0277 11.5942 17.5645V12.4345C11.5942 11.9713 11.9446 11.5945 12.3754 11.5945Z",
    fill: "#0052FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6804_35251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoinbase);
export default __webpack_public_path__ + "static/media/icon-coinbase.4f401852a63bd00f6d7378147614adc6.svg";
export { ForwardRef as ReactComponent };